
<div class="container">
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" *ngIf="partnerApiSuccess.length &gt; 0">
    <div class="col">
      <div class="alert alert-success"><span>{{ partnerApiSuccess }}</span></div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p class="text-center">Send installation data to the project's partner</p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col">
      <p class="text-center">Warning: On click of below button, you are about to download an excel macro file(XLSM), kindly ensure to perform an anti-virus scan against the downloaded file for security vulnerabilities</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" id="exportPartnerButton" (click)="downloadPartnerInstallFile()"><span class="oi oi-cloud-download"></span> Export Partner Installation Form</a>
      <md-spinner-block class="pb-1" *ngIf="isFileDownloading"></md-spinner-block>
    </div>
    <div class="col" *ngIf="allowSendingToPartner.valid"> </div>
    <div class="col" *ngIf="allowSendingToPartner.valid"><a class="btn btn-primary btn-block" id="sendDeploymentButton" href="javascript:void(0)" (click)="sendDeployToPartner()"><span class="oi oi-envelope-closed"></span> Send Deployment to Installation Partner</a></div>
    <div class="col"> </div>
  </div>
</div>